import { useEffect, useMemo, useRef, useState } from "react";

const STORAGE_KEY = "propertysphere_theme";

const THEMES = [
  {
    id: "line",
    label: "Line",
    swatch: "#22c55e",
    topbarBg: "#0f766e",
    topbarText: "#ecfeff",
    topbarBorder: "rgba(236,254,255,0.35)",
    topbarHover: "rgba(236,254,255,0.16)",
    menuActiveBg: "#d1fae5",
    menuActiveText: "#065f46",
    chipBg: "#fef08a",
    chipText: "#3f3f46",
    appBg: "#f8fafc",
    appText: "#0f172a",
    appPanel: "#ffffff",
    appMuted: "#6b7280",
    appLine: "#eef2f7",
    appPrimary: "#2563eb",
    appPrimaryHover: "#1d4ed8",
    fyPageBg:
      "radial-gradient(circle at 15% 0%, rgba(192, 149, 74, 0.14), transparent 30%), radial-gradient(circle at 80% 20%, rgba(36, 52, 105, 0.22), transparent 35%), linear-gradient(180deg, #020917 0%, #020a1a 55%, #010815 100%)",
    fyShellBg: "rgba(5, 15, 34, 0.9)",
    fyShellBorder: "rgba(197, 155, 75, 0.35)",
    fyHeroTitle: "#e6ebf8",
    fyHeroAccent: "#ddb35a",
    fySubtext: "#8ca1c4",
    fyPrimary: "#d2a84e",
    fyPrimaryText: "#101625",
    fyCardBg: "rgba(12, 25, 53, 0.82)",
    fyCardTopBg: "rgba(22, 39, 75, 0.84)",
    scrollbarTrack: "#071327",
    scrollbarThumb: "#d2a84e"
  },
  {
    id: "ocean",
    label: "Ocean",
    swatch: "#0ea5e9",
    topbarBg: "#0c4a6e",
    topbarText: "#e0f2fe",
    topbarBorder: "rgba(224,242,254,0.35)",
    topbarHover: "rgba(224,242,254,0.16)",
    menuActiveBg: "#dbeafe",
    menuActiveText: "#1d4ed8",
    chipBg: "#bfdbfe",
    chipText: "#1e3a8a",
    appBg: "#f0f9ff",
    appText: "#082f49",
    appPanel: "#ffffff",
    appMuted: "#4b5563",
    appLine: "#dbeafe",
    appPrimary: "#0284c7",
    appPrimaryHover: "#0369a1",
    fyPageBg:
      "radial-gradient(circle at 15% 0%, rgba(14, 165, 233, 0.16), transparent 30%), radial-gradient(circle at 85% 10%, rgba(59, 130, 246, 0.2), transparent 36%), linear-gradient(180deg, #031126 0%, #041736 55%, #031128 100%)",
    fyShellBg: "rgba(7, 27, 57, 0.9)",
    fyShellBorder: "rgba(59, 130, 246, 0.36)",
    fyHeroTitle: "#d9ecff",
    fyHeroAccent: "#7dd3fc",
    fySubtext: "#a9c3e9",
    fyPrimary: "#38bdf8",
    fyPrimaryText: "#03253a",
    fyCardBg: "rgba(15, 38, 74, 0.86)",
    fyCardTopBg: "rgba(22, 52, 98, 0.86)",
    scrollbarTrack: "#072346",
    scrollbarThumb: "#38bdf8"
  },
  {
    id: "sunset",
    label: "Sunset",
    swatch: "#f97316",
    topbarBg: "#9a3412",
    topbarText: "#ffedd5",
    topbarBorder: "rgba(255,237,213,0.35)",
    topbarHover: "rgba(255,237,213,0.16)",
    menuActiveBg: "#ffedd5",
    menuActiveText: "#9a3412",
    chipBg: "#fde68a",
    chipText: "#78350f",
    appBg: "#fff7ed",
    appText: "#7c2d12",
    appPanel: "#ffffff",
    appMuted: "#7c5a4a",
    appLine: "#fed7aa",
    appPrimary: "#ea580c",
    appPrimaryHover: "#c2410c",
    fyPageBg:
      "radial-gradient(circle at 20% 0%, rgba(249, 115, 22, 0.2), transparent 30%), radial-gradient(circle at 85% 20%, rgba(251, 146, 60, 0.18), transparent 34%), linear-gradient(180deg, #2a1008 0%, #261008 50%, #1e0c06 100%)",
    fyShellBg: "rgba(45, 18, 10, 0.88)",
    fyShellBorder: "rgba(251, 146, 60, 0.34)",
    fyHeroTitle: "#ffe8d5",
    fyHeroAccent: "#fdba74",
    fySubtext: "#f8c5a0",
    fyPrimary: "#fb923c",
    fyPrimaryText: "#341304",
    fyCardBg: "rgba(67, 29, 16, 0.82)",
    fyCardTopBg: "rgba(88, 38, 20, 0.84)",
    scrollbarTrack: "#341505",
    scrollbarThumb: "#fb923c"
  },
  {
    id: "violet",
    label: "Violet",
    swatch: "#8b5cf6",
    topbarBg: "#5b21b6",
    topbarText: "#f3e8ff",
    topbarBorder: "rgba(243,232,255,0.35)",
    topbarHover: "rgba(243,232,255,0.16)",
    menuActiveBg: "#ede9fe",
    menuActiveText: "#5b21b6",
    chipBg: "#ddd6fe",
    chipText: "#4c1d95",
    appBg: "#f5f3ff",
    appText: "#2e1065",
    appPanel: "#ffffff",
    appMuted: "#5b4c85",
    appLine: "#ddd6fe",
    appPrimary: "#7c3aed",
    appPrimaryHover: "#6d28d9",
    fyPageBg:
      "radial-gradient(circle at 20% 0%, rgba(139, 92, 246, 0.2), transparent 30%), radial-gradient(circle at 85% 20%, rgba(99, 102, 241, 0.2), transparent 35%), linear-gradient(180deg, #180b3a 0%, #140832 55%, #10062a 100%)",
    fyShellBg: "rgba(24, 12, 53, 0.88)",
    fyShellBorder: "rgba(167, 139, 250, 0.34)",
    fyHeroTitle: "#ede9fe",
    fyHeroAccent: "#c4b5fd",
    fySubtext: "#c8b8eb",
    fyPrimary: "#a78bfa",
    fyPrimaryText: "#1f1245",
    fyCardBg: "rgba(35, 18, 69, 0.82)",
    fyCardTopBg: "rgba(49, 26, 94, 0.84)",
    scrollbarTrack: "#1e0d3e",
    scrollbarThumb: "#a78bfa"
  },
  {
    id: "graphite",
    label: "Graphite",
    swatch: "#334155",
    topbarBg: "#1e293b",
    topbarText: "#e2e8f0",
    topbarBorder: "rgba(226,232,240,0.3)",
    topbarHover: "rgba(226,232,240,0.14)",
    menuActiveBg: "#e2e8f0",
    menuActiveText: "#0f172a",
    chipBg: "#cbd5e1",
    chipText: "#0f172a",
    appBg: "#f1f5f9",
    appText: "#0f172a",
    appPanel: "#ffffff",
    appMuted: "#475569",
    appLine: "#cbd5e1",
    appPrimary: "#334155",
    appPrimaryHover: "#1e293b",
    fyPageBg:
      "radial-gradient(circle at 15% 0%, rgba(100, 116, 139, 0.2), transparent 30%), radial-gradient(circle at 85% 20%, rgba(71, 85, 105, 0.2), transparent 35%), linear-gradient(180deg, #0b1220 0%, #0b1628 55%, #08101d 100%)",
    fyShellBg: "rgba(13, 23, 40, 0.9)",
    fyShellBorder: "rgba(148, 163, 184, 0.32)",
    fyHeroTitle: "#e2e8f0",
    fyHeroAccent: "#cbd5e1",
    fySubtext: "#94a3b8",
    fyPrimary: "#94a3b8",
    fyPrimaryText: "#0f172a",
    fyCardBg: "rgba(20, 31, 50, 0.84)",
    fyCardTopBg: "rgba(29, 44, 68, 0.84)",
    scrollbarTrack: "#0b1524",
    scrollbarThumb: "#94a3b8"
  },
  {
    id: "tide",
    label: "Tide",
    swatch: "#14b8a6",
    motion: "water",
    topbarBg: "#0f766e",
    topbarText: "#e6fffb",
    topbarBorder: "rgba(230,255,251,0.35)",
    topbarHover: "rgba(230,255,251,0.14)",
    menuActiveBg: "#ccfbf1",
    menuActiveText: "#0f766e",
    chipBg: "#99f6e4",
    chipText: "#115e59",
    appBg: "#ecfeff",
    appText: "#134e4a",
    appPanel: "#ffffff",
    appMuted: "#456460",
    appLine: "#b7efe6",
    appPrimary: "#0d9488",
    appPrimaryHover: "#0f766e",
    fyPageBg:
      "radial-gradient(circle at 20% 12%, rgba(20, 184, 166, 0.22), transparent 34%), radial-gradient(circle at 84% 18%, rgba(34, 211, 238, 0.18), transparent 34%), linear-gradient(180deg, #021522 0%, #032036 52%, #031928 100%)",
    fyShellBg: "rgba(7, 29, 45, 0.9)",
    fyShellBorder: "rgba(45, 212, 191, 0.36)",
    fyHeroTitle: "#daf4f7",
    fyHeroAccent: "#7de6d8",
    fySubtext: "#9fc9ce",
    fyPrimary: "#47d8c6",
    fyPrimaryText: "#03232a",
    fyCardBg: "rgba(14, 40, 63, 0.84)",
    fyCardTopBg: "rgba(21, 58, 91, 0.84)",
    scrollbarTrack: "#082638",
    scrollbarThumb: "#47d8c6"
  },
  {
    id: "aurora",
    label: "Aurora",
    swatch: "#22d3ee",
    motion: "aurora",
    topbarBg: "#1e1b4b",
    topbarText: "#f5f3ff",
    topbarBorder: "rgba(245,243,255,0.33)",
    topbarHover: "rgba(245,243,255,0.14)",
    menuActiveBg: "#e0e7ff",
    menuActiveText: "#3730a3",
    chipBg: "#c4b5fd",
    chipText: "#312e81",
    appBg: "#f5f3ff",
    appText: "#1f1b4b",
    appPanel: "#ffffff",
    appMuted: "#574f89",
    appLine: "#ddd6fe",
    appPrimary: "#4f46e5",
    appPrimaryHover: "#4338ca",
    fyPageBg:
      "radial-gradient(circle at 15% 0%, rgba(34, 211, 238, 0.18), transparent 34%), radial-gradient(circle at 82% 15%, rgba(168, 85, 247, 0.2), transparent 34%), linear-gradient(180deg, #120b2c 0%, #150f33 56%, #100b28 100%)",
    fyShellBg: "rgba(24, 16, 56, 0.9)",
    fyShellBorder: "rgba(147, 197, 253, 0.34)",
    fyHeroTitle: "#ecebff",
    fyHeroAccent: "#93c5fd",
    fySubtext: "#b3b9ea",
    fyPrimary: "#7dd3fc",
    fyPrimaryText: "#11173d",
    fyCardBg: "rgba(33, 22, 71, 0.84)",
    fyCardTopBg: "rgba(46, 31, 95, 0.84)",
    scrollbarTrack: "#18113d",
    scrollbarThumb: "#7dd3fc"
  },
  {
    id: "pulse",
    label: "Pulse",
    swatch: "#f43f5e",
    motion: "interactive",
    topbarBg: "#831843",
    topbarText: "#ffe4f2",
    topbarBorder: "rgba(255,228,242,0.34)",
    topbarHover: "rgba(255,228,242,0.16)",
    menuActiveBg: "#ffe4e6",
    menuActiveText: "#9f1239",
    chipBg: "#fecdd3",
    chipText: "#881337",
    appBg: "#fff1f2",
    appText: "#4c0519",
    appPanel: "#ffffff",
    appMuted: "#7b4157",
    appLine: "#fecdd3",
    appPrimary: "#e11d48",
    appPrimaryHover: "#be123c",
    fyPageBg:
      "radial-gradient(circle at 20% 8%, rgba(244, 63, 94, 0.18), transparent 35%), radial-gradient(circle at 84% 16%, rgba(251, 113, 133, 0.16), transparent 33%), linear-gradient(180deg, #270816 0%, #200713 54%, #18050f 100%)",
    fyShellBg: "rgba(43, 12, 28, 0.9)",
    fyShellBorder: "rgba(251, 113, 133, 0.36)",
    fyHeroTitle: "#ffe5ee",
    fyHeroAccent: "#fda4af",
    fySubtext: "#edb6c9",
    fyPrimary: "#fb7185",
    fyPrimaryText: "#2f0a1a",
    fyCardBg: "rgba(56, 17, 34, 0.84)",
    fyCardTopBg: "rgba(72, 23, 43, 0.84)",
    scrollbarTrack: "#310b1d",
    scrollbarThumb: "#fb7185"
  }
];

function applyTheme(theme) {
  if (!theme || typeof document === "undefined") return;
  const root = document.documentElement;
  root.dataset.themeMotion = theme.motion || "none";
  root.style.setProperty("--theme-topbar-bg", theme.topbarBg);
  root.style.setProperty("--theme-topbar-text", theme.topbarText);
  root.style.setProperty("--theme-topbar-border", theme.topbarBorder);
  root.style.setProperty("--theme-topbar-hover", theme.topbarHover);
  root.style.setProperty("--theme-menu-active-bg", theme.menuActiveBg);
  root.style.setProperty("--theme-menu-active-text", theme.menuActiveText);
  root.style.setProperty("--theme-chip-bg", theme.chipBg);
  root.style.setProperty("--theme-chip-text", theme.chipText);
  root.style.setProperty("--app-bg", theme.appBg);
  root.style.setProperty("--app-text", theme.appText);
  root.style.setProperty("--wf-panel", theme.appPanel);
  root.style.setProperty("--wf-muted", theme.appMuted);
  root.style.setProperty("--wf-line", theme.appLine);
  root.style.setProperty("--wf-primary", theme.appPrimary);
  root.style.setProperty("--wf-primary-hover", theme.appPrimaryHover);
  root.style.setProperty("--fy-page-bg", theme.fyPageBg);
  root.style.setProperty("--fy-shell-bg", theme.fyShellBg);
  root.style.setProperty("--fy-shell-border", theme.fyShellBorder);
  root.style.setProperty("--fy-hero-title", theme.fyHeroTitle);
  root.style.setProperty("--fy-hero-accent", theme.fyHeroAccent);
  root.style.setProperty("--fy-subtext", theme.fySubtext);
  root.style.setProperty("--fy-primary", theme.fyPrimary);
  root.style.setProperty("--fy-primary-text", theme.fyPrimaryText);
  root.style.setProperty("--fy-card-bg", theme.fyCardBg);
  root.style.setProperty("--fy-card-top-bg", theme.fyCardTopBg);
  root.style.setProperty("--app-scrollbar-track", theme.scrollbarTrack);
  root.style.setProperty("--app-scrollbar-thumb", theme.scrollbarThumb);
}

function getThemeById(themeId) {
  return THEMES.find((theme) => theme.id === themeId) || THEMES[0];
}

export function applySavedTheme() {
  if (typeof window === "undefined") {
    return;
  }
  const saved = window.localStorage.getItem(STORAGE_KEY);
  const initial = getThemeById(saved);
  applyTheme(initial);
  return initial.id;
}

export default function ThemeSelector({ buttonLabel = "Theme", panelLabel = "Theme" }) {
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [activeThemeId, setActiveThemeId] = useState("line");

  const activeTheme = useMemo(
    () => THEMES.find((theme) => theme.id === activeThemeId) || THEMES[0],
    [activeThemeId]
  );

  useEffect(() => {
    const initialThemeId = applySavedTheme();
    if (initialThemeId) {
      setActiveThemeId(initialThemeId);
    }
  }, []);

  useEffect(() => {
    const onClickOutside = (event) => {
      if (!rootRef.current || rootRef.current.contains(event.target)) {
        return;
      }
      setOpen(false);
    };

    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  useEffect(() => {
    const onThemeEvent = (event) => {
      const nextThemeId = event?.detail?.id;
      if (!nextThemeId || nextThemeId === activeThemeId) {
        return;
      }
      const matched = THEMES.find((theme) => theme.id === nextThemeId);
      if (matched) {
        setActiveThemeId(matched.id);
      }
    };

    window.addEventListener("propertysphere-theme-change", onThemeEvent);
    return () => window.removeEventListener("propertysphere-theme-change", onThemeEvent);
  }, [activeThemeId]);

  const onSelectTheme = (theme) => {
    setActiveThemeId(theme.id);
    applyTheme(theme);
    localStorage.setItem(STORAGE_KEY, theme.id);
    window.dispatchEvent(new CustomEvent("propertysphere-theme-change", { detail: { id: theme.id } }));
    setOpen(false);
  };

  return (
    <div className="theme-selector" ref={rootRef}>
      <button
        type="button"
        className="theme-toggle"
        onClick={() => setOpen((prev) => !prev)}
        title={`${panelLabel}: ${activeTheme.label}`}
      >
        {buttonLabel}
      </button>

      {open ? (
        <div className="theme-popover" role="menu" aria-label={`${panelLabel} selector`}>
          <div className="theme-popover-label">{panelLabel}: {activeTheme.label}</div>
          <div className="theme-grid">
            {THEMES.map((theme) => (
              <button
                key={theme.id}
                type="button"
                className={`theme-swatch ${activeThemeId === theme.id ? "active" : ""}`}
                style={{ background: theme.swatch }}
                aria-label={theme.label}
                onClick={() => onSelectTheme(theme)}
              />
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
